import { PropTypes } from "prop-types";
import styled from "styled-components";
import { faTrashAlt, faGripVertical, faPencil } from "pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMutation } from "react-query";
import { up } from 'styled-breakpoints';
import Swal from "sweetalert2";
import { trackEventSegment } from "../utils/segmentUtils";
import { removeMenu } from "../api/mutations";

const Wrap = styled.div`
  display: flex;
  border: 2px #e5e5e5 solid;
  border-radius: 10px;
  width: 100%;
  margin-bottom: 2em;
  padding: 2em;
  box-sizing: border-box;
  background: white;
`;

const Title = styled.span`
  font-weight: 500;
  font-size: 1.15em;
  align-self: center;
  color: #626262;
`;

const Content = styled.div`
  display: flex;
  flex: 1;
`;

const Buttons = styled.div`
  display: flex;
  align-self: center;
  width: 33%;
  justify-content: space-between;

  ${up('xs')} {
    width: 35%;
  }

  ${up('sm')} {
    width: 25%;
  }

  ${up('md')} {
    width: 22%;
  }

  ${up('lg')} {
    width: 18%;
  }

  ${up('xl')} {
    width: 15%;
  }

  ${up('xxl')} {
    width: 12%;
  }
`;

const MenuListItem = (props) => {
  const [mutate] = useMutation(removeMenu);

  const clickDelete = () => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      text: "Deleting this menu will also delete any menu sections associated with it.",
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      showLoaderOnConfirm: true,
      preConfirm: async (result) => {
        await mutate(
          { menuId: props.menu.uuid },
          {
            onError: (resError) => {
              props.addMenu(props.menu.uuid);
            },
            onSuccess: () => {
              trackEventSegment("Removed Menu", {
                uuid: props.menu.uuid,
                name: props.menu.name,
              });
            },
          }
        );
        props.removeMenu(props.menu.uuid);
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  };

  return (
    <Wrap>
      <Content>
        <Title>{props.menu.name}</Title>
      </Content>
      <Buttons>
        <FontAwesomeIcon color={"#919191"} size="lg" icon={faPencil} onClick={() => props.editMenu(props.menu)} />
        <FontAwesomeIcon color={"#919191"} size="lg" icon={faTrashAlt} onClick={clickDelete} />
        <FontAwesomeIcon color={"#919191"} size="lg" icon={faGripVertical} />
      </Buttons>
    </Wrap>
  );
};

MenuListItem.propTypes = {
  menu: PropTypes.object.isRequired,
  removeMenu: PropTypes.func.isRequired,
  addMenu: PropTypes.func.isRequired,
  editMenu: PropTypes.func.isRequired,
};

export default MenuListItem;
